if (!customElements.get('q-reviews-cards')) {
  class ReviewsCards extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.swiper = null;
      this.retryTimer = null;
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
    }

    connectedCallback() {
      this.initSwiper();
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
    }

    disconnectedCallback() {
      this.destroySwiper();
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      this.clearRetry();
    }

    clearRetry() {
      if (!this.retryTimer) return;
      window.clearTimeout(this.retryTimer);
      this.retryTimer = null;
    }

    handleSectionLoad(event) {
      if (!event.target || !event.target.contains(this)) return;
      this.destroySwiper();
      this.initSwiper();
    }

    initSwiper() {
      const slider = this.querySelector('.qrevi-swiper');
      if (!slider) return;

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.update();
        return;
      }

      if (!window.FoxTheme || typeof window.FoxTheme.Carousel !== 'function') {
        this.clearRetry();
        this.retryTimer = window.setTimeout(() => this.initSwiper(), 150);
        return;
      }

      this.clearRetry();

      if (slider.swiper && !slider.swiper.destroyed) {
        slider.swiper.destroy(true, true);
      }

      const sliderOptions = {
        loop: true,
        slidesPerView: (Number(this.dataset.columnsMobile) || 1) + 0.15,
        centeredSlides: true,
        spaceBetween: 12,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        threshold: 2,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        roundLengths: true,
        updateOnWindowResize: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: this.querySelector('.qrevi-next'),
          prevEl: this.querySelector('.qrevi-prev'),
        },
        pagination: {
          el: this.querySelector('.qrevi-pagination'),
          type: 'progressbar',
        },
        breakpoints: {
          768: {
            slidesPerView: Math.min(Number(this.dataset.columnsDesktop) || 4, 3),
            centeredSlides: false,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          1280: {
            slidesPerView: Number(this.dataset.columnsDesktop) || 4,
            centeredSlides: false,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
        on: {
          init(swiper) {
            window.requestAnimationFrame(() => swiper.update());
          },
          imagesReady(swiper) {
            swiper.update();
          },
          resize(swiper) {
            swiper.update();
          },
        },
      };

      this.carousel = new window.FoxTheme.Carousel(slider, sliderOptions);
      this.carousel.init();
      this.swiper = this.carousel.slider;
    }

    destroySwiper() {
      this.clearRetry();

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.carousel = null;
      this.swiper = null;
    }
  }

  customElements.define('q-reviews-cards', ReviewsCards);
}
